import { useNavigate } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import employees from 'modules/employees/store/collections/employees'
import RemoveLegalEntityPage from 'modules/settings/components/Payroll/LegalEntities/RemoveLegalEntityPage'

const RemovePage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()

  const { loading } = useAsyncData(() => employees.fetch({ withCachedFetchParams: true }), [])

  const onClose = () => {
    navigate(navigation.settings.details.fullPath())
  }

  if (loading) {
    return null
  }

  return (
    <RemoveLegalEntityPage onClose={onClose} legalEntityId={id ?? ''} employees={employees} />
  )
}

export default RemovePage
